export const freeServices = [
  {
    href: 'formSuccessFreeServicesTagMapLink',
    title: 'formSuccessFreeServicesTagMap',
  },
  {
    href: 'formSuccessFreeServicesTagFloorLink',
    title: 'formSuccessFreeServicesTagFloor',
  },
  {
    href: 'formSuccessFreeServicesTagConstructorLink',
    title: 'formSuccessFreeServicesTagConstructor',
  },
  {
    href: 'formSuccessFreeServicesTagReviewLink',
    title: 'formSuccessFreeServicesTagReview',
  },
  {
    href: 'formSuccessFreeServicesTagRatingLink',
    title: 'formSuccessFreeServicesTagRating',
  },
];
